import * as React from "react";
import StoreContainer from "../stores/StoreContainer";
import { DynamicButtonConfiguration } from "../types";

interface DynamicButtonProps {
  isChatAvailable: boolean;
  onClick: () => void;
}

interface DynamicButtonState {
  config: DynamicButtonConfiguration;
}

class DynamicButton extends React.Component<
  DynamicButtonProps,
  DynamicButtonState
> {
  state = {
    config: StoreContainer.DynamicButtonStore.getConfig()
  };

  componentDidMount() {
    if (!this.state.config) {
      StoreContainer.DynamicButtonStore.onConfigLoaded(this.onConfigLoaded);
      StoreContainer.DynamicButtonStore.load();
    }
  }

  onConfigLoaded = () => {
    this.setState({
      config: StoreContainer.DynamicButtonStore.getConfig()
    });
  };

  handleClick = () => {
    this.props.onClick();
  };

  getSrc() {
    var config = this.state.config;
    if (!config) {
      return null;
    }

    return this.props.isChatAvailable
      ? config.DynamicButtonOnlineUrl
      : config.DynamicButtonOfflineUrl;
  }

  render() {
    const src = this.getSrc();

    if (!src) {
      return null;
    }

    return (
      <img
        onClick={() => this.handleClick()}
        onKeyDown={e => {
          return e.keyCode !== 13 || this.handleClick();
        }}
        src={src}
        alt="Open Live Chat"
        tabIndex={0}
        style={{ cursor: "pointer" }}
        role="button"
      />
    );
  }
}

export default DynamicButton;
